import { ArrowCircleLeft } from "@phosphor-icons/react";
import Input from "../../components/Input";
import{
    Container,
    ContainerRow,
    ContainerCollumContent,
    BoxForm,
    Title,
    Button,
    BoxContent,
    FooterItem,
    BoxFooter,
    SelectContent,
    Select,
    Option
} from "../../styles/shared";


import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { NotaService } from "./services/NotaService";
import { Toaster, toast } from 'sonner'
import { format } from 'date-fns'

function Nota() {
    const navigate = useNavigate();
    const [arquivo, setArquivo] = useState(null);
    const [numeroInicial, setNumeroInicial] = useState(0);
    const [serie, setSerie] = useState('');
    const [aliquota, setAliquota] = useState('');
    const [loteInicial, setLoteInicial] = useState('');
    const [empresas, setEmpresas] = useState([])
    const [empresa, setEmpresa] = useState('')

    const getCurrentDateTime = () => {
        const now = new Date();
        return format(now, "yyyy-MM-dd'T'HH:mm"); // Formato esperado pelo input datetime-local
    };

    const [competencia, setCompetencia] = useState(getCurrentDateTime());

    const getEmpresas = useCallback(async () => {
        try {
            const response = await NotaService.getEmpresas()
            setEmpresas(response)
            setEmpresa(response[0].id_empresa)
        } catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        getEmpresas()
    }, [getEmpresas])

    const downloadNota = (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'nota.zip');
        document.body.appendChild(link);
        link.click();
    }

    const handleGerarNota = async () => {
        const formData = new FormData();
        formData.append('arquivo', arquivo);
        formData.append('numeroInicial', numeroInicial);
        formData.append('serie', serie);
        formData.append('aliquota', aliquota);
        formData.append('loteInicial', loteInicial);
        formData.append('idEmpresa', empresa);

        // Converter para o formato ISO (com fuso horário Z e milissegundos)
        // const competenciaISO = formatISO(new Date(competencia))
        // formData.append('competencia', competenciaISO);

        const competenciaISO = new Date(competencia);
        competenciaISO.setHours(competenciaISO.getHours() - 3); 
        formData.append('competencia', competenciaISO.toISOString());

        // formData.entries().forEach((entry) => {
        //     console.log(entry);
        // });
        try {
            const response = await NotaService.gerar(formData);
            downloadNota(response);
            toast.success('Nota gerada com sucesso');
            // toast.promise(await NotaService.gerar(formData), {
            //     loading: 'Gerando nota...',
            //     success: (response) => {
            //         downloadNota(response);
            //         return 'Nota gerada com sucesso';
            //     },
            //     error: 'Erro ao gerar nota',
            // });
        } catch (error) {
            console.error('Error:', error);
            toast.error('Erro ao gerar nota');
        }
    };
  return (
    <Container>
        <ContainerRow>
            <ContainerCollumContent>
                <BoxForm>
                    <Title>Gerar Nota</Title>
                    <BoxFooter>
                    <FooterItem>
                        <Button onClick={() => navigate(-1)}>
                            <ArrowCircleLeft />
                            Voltar
                        </Button>
                    </FooterItem>
                    </BoxFooter>
                    <BoxContent>
                        <SelectContent>
                            <label htmlFor="">Empresa</label>
                            <Select value={empresa} onChange={(e) => setEmpresa(e.target.value)}>
                                {empresas.map((empresa) => (
                                    <Option key={empresa.id_empresa} value={empresa.id_empresa}>{empresa.nome_empresa}</Option> 
                                ))}
                            </Select>
                        </SelectContent>
                        <Input label="Competência" type='datetime-local' value={competencia} onChange={(e) => setCompetencia(e.target.value)}/>
                        <Input
                            label="Arquivo CSV"
                            type="file"
                            onChange={(e) => setArquivo(e.target.files[0])}
                            accept=".csv"
                        />
                        <Input palsceholder="Digite o número inicial" label="Número Inicial" type='number' value={numeroInicial} onChange={(e) => setNumeroInicial(e.target.value)}/>
                        <Input placeholder="Digite o valor de série" type="text" label="Série" onChange={(e) => setSerie(e.target.value)}/>
                        <Input placeholder="Digite o valor de alíquota" type="text" label="Alíquota" onChange={(e) => setAliquota(e.target.value)}/>
                        <Input placeholder="Digite o valor de lote inicial" type='number' value={loteInicial} label="Lote Inicial" onChange={(e) => setLoteInicial(e.target.value)}/>
                        <Button onClick={() => handleGerarNota()}>Gerar</Button>
                    </BoxContent>
                </BoxForm>
            </ContainerCollumContent>
        </ContainerRow>
        <Toaster position="top-right" richColors duration={1000 * 2.5}/>
    </Container>
  )
}

export default Nota